<template>
  <div class="hab-range" :class="className">
    <div class="range">
      <label v-if="label" class="name"
        >{{ label }}<span v-if="required"></span
      ></label>
      <vue-slider
        :value="value"
        :contained="true"
        :min="min"
        :max="max"
        :interval="step"
        :disabled="disabled"
        :process="true"
        :tooltip="tooltip"
        :enable-cross="false"
        :dotSize="dotSize"
        :height="height"
        :marks="marks"
        :tooltip-formatter="tooltipFormatter"
        @change="onChange"
      ></vue-slider>
    </div>
    <span v-if="error" class="alert-input-error">{{ error }}</span>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  components: {
    VueSlider,
  },
  props: {
    className: {
      type: String,
      default: "",
    },
    tooltip: {
      type: String,
      default: "always",
    },
    marks: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default() {
        return [0, 0];
      },
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 8,
    },
    step: {
      type: Number,
      default: 5,
    },
    dotSize: {
      type: Number,
      default: 16,
    },
    tooltipFormatter: {
      type: [Function, String],
      default: null,
    },
  },
  emits: ["onRange"],
  data() {
    return {
      isChecked: false,
    };
  },
  methods: {
    onChange(value, index) {
      return this.$emit("onRange", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.hab-range {
  user-select: none;
  position: relative;
  .range {
    .name {
      font-size: 14px;
      font-weight: 500;
      line-height: 120%;
      margin: 0;
      margin-bottom: 10px;
      span {
        margin-left: 4px;
        &::before {
          content: "*";
          color: #f00;
        }
      }
    }
  }
}
</style>
